import { Add, Remove } from "@mui/icons-material";
import { Card, Checkbox, Chip, IconButton, Paper, Stack, Typography } from "@mui/material";
import { getWordDeclension } from "helpers/index";
import { palette } from "theme";
import { QUESTION_TYPE_OPTIONS } from "../../constants";
import { QuestionTypeCountMap } from "../../types";
import { getQuestionTypeCount } from "../../utils";

interface QuestionTypesBlockProps {
  questionTypeCounts: QuestionTypeCountMap;
  totalActiveTypes: number;
  errorMessage?: string;
  onToggleQuestionType: (questionTypeId: (typeof QUESTION_TYPE_OPTIONS)[number]["id"], checked: boolean) => void;
  onAdjustQuestionType: (questionTypeId: (typeof QUESTION_TYPE_OPTIONS)[number]["id"], delta: number) => void;
}

const QuestionTypesBlock = ({
  questionTypeCounts,
  totalActiveTypes,
  errorMessage,
  onToggleQuestionType,
  onAdjustQuestionType,
}: QuestionTypesBlockProps) => (
  <Card sx={{ p: 1.5 }}>
    <Stack spacing={1.5}>
      <Stack
        direction='row'
        justifyContent='space-between'
        alignItems='center'>
        <Typography variant='h6'>Вопросы</Typography>
        <Chip
          label={`${totalActiveTypes} ${getWordDeclension(totalActiveTypes, "type")}`}
          sx={{ backgroundColor: palette.third.main, color: palette.primary.main, "& span": { fontWeight: 600 } }}
          size='small'
        />
      </Stack>
      <Stack spacing={0.5}>
        {QUESTION_TYPE_OPTIONS.map((item) => {
          const count = getQuestionTypeCount(questionTypeCounts, item.id);
          const isActive = count > 0;

          return (
            <Paper
              key={item.id}
              variant='outlined'
              sx={{
                px: 1,
                py: 0.5,
                display: "flex",
                alignItems: "center",
                gap: 1,
                opacity: isActive ? 1 : 0.72,
              }}>
              <Checkbox
                checked={isActive}
                onChange={(_, checked) => onToggleQuestionType(item.id, checked)}
                sx={{ p: 0, m: 0 }}
              />
              <Stack
                spacing={0.25}
                sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography
                  variant='body14rg'
                  fontWeight={600}>
                  {item.label}
                </Typography>
              </Stack>
              <Stack
                direction='row'
                alignItems='center'
                spacing={0.25}>
                <IconButton
                  size='small'
                  disabled={!count}
                  onClick={() => onAdjustQuestionType(item.id, -1)}>
                  <Remove fontSize='small' />
                </IconButton>
                <Typography
                  sx={{
                    minWidth: 20,
                    textAlign: "center",
                    fontWeight: 700,
                  }}>
                  {count}
                </Typography>
                <IconButton
                  size='small'
                  onClick={() => onAdjustQuestionType(item.id, 1)}>
                  <Add fontSize='small' />
                </IconButton>
              </Stack>
            </Paper>
          );
        })}
      </Stack>
      {!!errorMessage && (
        <Typography
          variant='body2'
          color='error.main'>
          {errorMessage}
        </Typography>
      )}
    </Stack>
  </Card>
);

export default QuestionTypesBlock;
